import { EventMeta } from '../../../interfaces/meta.interface';

const messageBind: EventMeta = {
    title: 'Message Bind',
    default: {
        description: 'Message Bind',
        longDescription: 'A message was viewed in the preview pane or opened by an admin (E3 users only).',
        severity: 'info',
    },
};

export default messageBind;
